import React, { useEffect } from 'react';
import {
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';

import './css/style.css';

import SignUp from './pages/sign-up';
import SignIn from './pages/sign-in';
import ProtectedRoute from './partials/protected-route';
import AppHome from './partials/app-home';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import ForgotPassword from './pages/forgot-password';
import ResetPassword from './pages/reset-password';
import ResendVerification from './pages/resend-verification';
import DiscordBanner from './partials/banner';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: Infinity,
    },
  },
});

function App() {

  const location = useLocation();


  useEffect(() => {
    const html = document.querySelector('html');
    if (html) {
      html.style.scrollBehavior = 'auto';
      window.scroll({ top: 0 });
      html.style.scrollBehavior = '';
    }

  }, [location.pathname]);
  
  return (
    <>
      <DiscordBanner/>
      {/* Routing goes here */}
      <QueryClientProvider client={queryClient}>
        <ToastContainer position="top-center"  />
        <Routes>
          <Route
            path='/*'
            element={(
              <ProtectedRoute>
                <AppHome />
              </ProtectedRoute>
            )}
          />
          <Route path='/sign-up' element={<SignUp />} />
          <Route path='/sign-in' element={<SignIn />} />
          <Route path='/forgot-password' element={<ForgotPassword />} />
          <Route path='/reset-password' element={<ResetPassword />} />
          <Route path='/resend-verification' element={<ResendVerification />} />
        </Routes>
      </QueryClientProvider>
    </>
  );
}

export default App;
